import { Strings } from "../../resources/i18n/i18n";

export const EXTERNAL_RECONCILIATION_TABLE_FIELDS = [
  {
    key: "sel",
    name: "",
    minWidth: 50,
  },
  {
    key: "od",
    name: Strings("operationDate"),
    minWidth: 130,
  },
  {
    key: "cd",
    name: Strings("MatricesID"),
    minWidth: 120,
  },
  {
    key: "ln",
    name: Strings("applicationId"),
    minWidth: 120,
  },
  {
    key: "amt",
    name: Strings("reconciledAmount"),
    minWidth: 150,
  },
  {
    key: "desc",
    name: Strings("reconciledDescription"),
    minWidth: 220,
  },
  {
    key: "st",
    name: Strings("reconciliationStatus"),
    minWidth: 120,
  },
  {
    key: "cb",
    name: Strings("createdBy"),
    minWidth: 160,
  },
  {
    key: "ub",
    name: Strings("updatedBy"),
    minWidth: 160,
  },
  {
    key: "ca",
    name: Strings("createdAt"),
    minWidth: 130,
  },
  {
    key: "ua",
    name: Strings("updatedAt"),
    minWidth: 130,
  },
];

// SearchFilter builds each option's value from a `||` chain, so an empty value
// is dropped and the browser reports the option's label instead. "All" therefore
// needs a non-empty sentinel; it is stripped before the request is sent.
export const RECONCILIATION_STATUS_ALL = "ALL";

export const RECONCILIATION_STATUS = [
  {
    key: 0,
    value: RECONCILIATION_STATUS_ALL,
    label: Strings("All"),
  },
  {
    key: 1,
    value: "PENDING",
    label: Strings("PENDING"),
  },
  {
    key: 2,
    value: "PAID",
    label: Strings("PAID"),
  },
];

export const RECONCILIATION_STATUS_VALUE = {
  PENDING: "PENDING",
  PAID: "PAID",
};

// dowloadedAction prepends "/reports", so this is relative to that.
export const DOWNLOAD_URL = "/external-reconciliation/download?fileType=";
